import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnvironmentSpecificResolver } from '../../environment-specific-resolver.service';
import { SharedFilesComponent } from './shared-files.component';
import { FilePreviewComponent } from './file-preview.component';
import { PublicSharedComponent } from './public-shared.component';
import { SharedLiveView } from './shared-live-view.component';
const routes: Routes = [{
  path: '',
  component: PublicSharedComponent,
  resolve: {envSpecific: EnvironmentSpecificResolver },
  children: [
    {
      path: 'shared-files',
      component: SharedFilesComponent
    },
    {
      path: 'shared-folder',
      component: SharedFilesComponent
    },
    {
      path: 'file-preview',
      component: FilePreviewComponent
    },
    {
      path: 'shared-live-view',
      component: SharedLiveView
    }
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicSharedRoutingModule { }
